import styled, { Scale, css, falconTheme } from '@secretescapes/falcon';

const horizontalPadding = css`
  padding: 0 ${Scale.m};
  background-color: ${falconTheme.color.white};
`;

const sectionsStructure = css`
  display: flex;
  flex-direction: column;
  gap: ${Scale.l};
`;

export const innerSectionStructure = css`
  display: flex;
  flex-direction: column;
  gap: ${Scale.m};
`;

export const BaseSectionWrapper = styled('div')`
  ${innerSectionStructure}
`;

export const BaseSectionsContainer = styled('div')`
  ${sectionsStructure}
`;

export const BreadcrumbsContainer = styled('div')`
  margin: ${Scale.xxs} ${Scale.m};
  padding: ${Scale.xxs} 0;
  overflow-x: auto;
`;

export const ContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.xs};
  padding-top: ${Scale.m};
`;

export const FacilitiesContainer = styled(BaseSectionWrapper)`
  ${horizontalPadding};
`;

export const KeyInformationContainer = styled(BaseSectionsContainer)`
  ${horizontalPadding};
`;

export const TitleBadgesContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.xs};
`;

export const InformationalContainer = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${Scale.m};
  align-items: center;

  > div {
    margin-right: 0;
  }
`;

export const PropertyDetailsWrapper = styled(BaseSectionWrapper)`
  margin-top: ${Scale.xs};
  ${horizontalPadding};
`;

export const LocationAndWhatsNearbyWrapper = styled(BaseSectionWrapper)`
  & > *:not(#map-wrapper) {
    ${horizontalPadding};
  }
`;

export const HighlightsContainer = styled('div')`
  a {
    text-decoration: underline !important;
    text-decoration-color: ${({ theme }) => theme.color.secondary60} !important;
  }
`;

export const AvailabilityPresentationSectionWrapper = styled('div')`
  background-color: ${({ theme }) => theme.color.grey05};

  > h4 {
    padding: ${Scale.m} ${Scale.m} 0;
  }
`;

export const DetailsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.l};
`;

export const OmnibusDirectiveWrapper = styled('div')`
  ${horizontalPadding};
`;

export const StyledSingleLineDiscountBadge = styled('div')`
  @media (min-width: 360px) {
    display: none;
  }
`;
